export default "/images/x-square.svg?009959ea315f430a0246898966000207";